var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSsp1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.61035 16.104L18.8046 4.3208L35.9987 16.104L18.8046 27.8873L1.61035 16.104ZM53.202 4.3208L36.0076 16.104L53.202 27.8873L70.3961 16.104L53.202 4.3208ZM53.1994 51.4723L36.0032 39.6908L53.1973 27.9075L70.3961 39.6908L53.1994 51.4723ZM18.819 58.067L36.0132 46.2839L53.2076 58.067L36.0132 69.8503L18.819 58.067ZM18.8046 27.9075L1.61035 39.6908L18.8046 51.4738L36.0032 39.6908L18.8046 27.9075Z",
    fill: "#FFCACF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsp1);
export default __webpack_public_path__ + "static/media/ssp_1.2989310f0b07f98ec8df1966d2146d1c.svg";
export { ForwardRef as ReactComponent };